/** Fallback de ruta PDP cuando el producto no tiene SKU ni tags. */
export const PRODUCT_DETAIL_PLACEHOLDER_SLUG = 'trim-dress';
